<script lang="ts">
  import { assets } from '$app/paths';
  import { apmonth } from 'journalize';
  import Fa from 'svelte-fa';
  import { faBurst } from '@fortawesome/free-solid-svg-icons';
  import MiniLocator from './MiniLocator/MiniLocator.svelte';

  export type Ship = {
    attack_date: string;
    vessel_name: string;
    flag: string;
    flag_code: string;
    vessel_type_label: string;
    vessel_type_icon: string;
    damage: string;
    latitude: number;
    longitude: number;
    imo: number | string;
    mmsi: number | string;
    year_built: number | string;
    length_m: number | string;
    dwt_tonnes: number | string;
    operator: string;
    source: string;
  };

  let { ship }: { ship: Ship } = $props();

  let attackDate = new Date(ship.attack_date);
</script>

<div class="ship">
  <div class="attack-date">
    <Fa icon={faBurst} />
    {apmonth(attackDate)}
    {attackDate.getDate()}
  </div>
  <div class="name">
    {#if ship.flag_code}
      <span class="fi fi-{ship.flag_code.toLowerCase()}"></span>
    {/if}
    {ship.vessel_name}
  </div>
  <div class="type">
    ({ship.vessel_type_label})
  </div>
  {#if ship.vessel_type_icon}
    <div class="icon">
      {#if ship.vessel_type_icon === 'bulker'}
        <img
          src="{assets}/images/post-18/ship-icons/bulker.png"
          alt="Bulker ship icon"
          aria-hidden="true"
        />
      {:else if ship.vessel_type_icon === 'tanker'}
        <img
          src="{assets}/images/post-18/ship-icons/tanker.png"
          alt="Tanker ship icon"
          aria-hidden="true"
        />
      {:else if ship.vessel_type_icon === 'container'}
        <img
          src="{assets}/images/post-18/ship-icons/container.png"
          alt="Container ship icon"
          aria-hidden="true"
        />
      {:else}
        <img
          src="{assets}/images/post-18/ship-icons/unknown.png"
          alt="Ship icon"
          aria-hidden="true"
        />
      {/if}
    </div>

    <div class="locator">
      <MiniLocator locator={[ship.latitude, ship.longitude]} />
    </div>
  {/if}
</div>

<style lang="scss">
  @use '@reuters-graphics/graphics-components/dist/scss/mixins' as mixins;

  .ship {
    display: flex;
    flex-direction: column;
    gap: 2px;
    @include mixins.font-note;
    width: 150px;
    text-align: left;
  }

  .icon {
    min-width: 120px;
    img {
      width: 100%;
      margin: 0;
    }
  }

  .attack-date {
    color: var(--theme-colour-accent);
    @include mixins.text-xxs;
    font-weight: bold;
  }
  .name {
    @include mixins.text-xs;
    font-weight: bold;
  }
  .type {
    @include mixins.text-xxs;
  }
  .locator {
    height: 80px;
  }
</style>
